export default "/images/CleanCarsforAllvideo.jpg";